import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const DEFAULT_PROPS = { open: false, tittle: '', message: '' };

export default function Modal(props) {
  const [properties, setProperties] = useState({ ...DEFAULT_PROPS, ...props });
  //const [obj, setObj] = useState([]);
  useEffect(() => {
    setProperties({ ...DEFAULT_PROPS, ...props });
    //console.log(props);
    //setObj(props.obj);
  }, [props]);

  const handleClose = () => {
    setProperties({ open: false });
  };

  return (
    <div>
      {/* <Toast {...toast} /> */}
      <Dialog
        open={Boolean(properties.open)}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{properties.tittle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {properties.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={props.handleDelete} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
